import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShoppingBag, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { useAuthStore } from '../store/auth';
import { useCartStore } from '../store/cart';
import styles from './CustomerLayout.module.css';

export default function CustomerLayout() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { accessToken, isAdmin, logout } = useAuthStore();
  const cartCount = useCartStore(s => s.count());
  const navigate = useNavigate();

  const toggleLang = () => i18n.changeLanguage(i18n.language === 'en' ? 'ta' : 'en');

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <Link to="/" className={styles.logo}>
            <span className={styles.logoText}>Sekar Silks</span>
            <span className={styles.logoSub}>Chennai • Est. 1984</span>
          </Link>

          <nav className={`${styles.nav} ${menuOpen ? styles.navOpen : ''}`}>
            <Link to="/" onClick={() => setMenuOpen(false)}>{t('nav.home')}</Link>
            <Link to="/catalogue" onClick={() => setMenuOpen(false)}>{t('nav.catalogue')}</Link>
            {accessToken && <Link to="/orders" onClick={() => setMenuOpen(false)}>{t('nav.orders')}</Link>}
            {isAdmin && <Link to="/admin" onClick={() => setMenuOpen(false)}>{t('nav.admin')}</Link>}
          </nav>

          <div className={styles.actions}>
            <button className={styles.langBtn} onClick={toggleLang}>
              {i18n.language === 'en' ? 'த' : 'EN'}
            </button>
            <Link to="/cart" className={styles.cartBtn}>
              <ShoppingBag size={22} />
              {cartCount > 0 && <span className={styles.cartBadge}>{cartCount}</span>}
            </Link>
            {accessToken
              ? <button className={styles.authBtn} onClick={() => { logout(); navigate('/'); }}>{t('nav.logout')}</button>
              : <Link to="/login" className={styles.authBtn}>{t('nav.login')}</Link>
            }
            <button className={styles.menuToggle} onClick={() => setMenuOpen(v => !v)}>
              {menuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerBrand}>
            <span className={styles.logoText}>Sekar Silks</span>
            <p>Premium sarees from Chennai since 1984</p>
          </div>
          <div className={styles.footerLinks}>
            <Link to="/catalogue">Catalogue</Link>
            <Link to="/orders">My Orders</Link>
            <a href="mailto:sekarsilks@gmail.com">Contact</a>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <p>© 2024 Sekar Silks. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
